var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_706)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.180641 2.52864C1.37017 3.31918 2.55023 4.11425 3.54632 5.13795C2.97534 7.57783 5.25421 9.52722 7.33257 10.6757C8.14619 11.1253 8.50581 11.4405 9.41156 11.289L12.9785 14.6699C6.26582 16.8509 -1.26756 7.70088 0.180641 2.52864ZM10.3311 10.4197L11.1135 9.65088C11.3391 9.42883 11.7116 9.42602 11.9411 9.64441L14.8259 12.3922C15.0553 12.6105 15.0582 12.9709 14.8326 13.1928L14.0499 13.9618C13.8242 14.1837 13.4517 14.1865 13.2222 13.9681L10.3374 11.2204C10.1078 11.0021 10.1051 10.6418 10.3311 10.4197ZM0.883733 0.911532L1.45156 0.244524C1.69496 -0.041372 2.1361 -0.0826328 2.43162 0.152847L5.38493 2.50654C5.68045 2.74227 5.72272 3.16879 5.47957 3.45505L4.91149 4.12169C4.66796 4.40796 4.22695 4.44885 3.9313 4.21337L0.978496 1.85968C0.682976 1.6242 0.640074 1.19743 0.883733 0.911532Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconDark);
export default __webpack_public_path__ + "static/media/phone-icon-dark.2c492eb36d3eb4fdb77772f2c9bc12b3.svg";
export { ForwardRef as ReactComponent };